import axios,{AxiosResponse} from "axios";
import configs from "../../configs/config";
import { ActionType } from "../../redux/actions/dashboard";

export const url = `${configs.BASE_URL}/contacttypes`;
const deleteUrl = `${configs.BASE_URL}/contacttypes/permanent/delete/`;
const bulkUpdate = `${configs.BASE_URL}/contacttypes/status/change?ids=`;

export const getContactType = (callback:any) => {
  return async (dispatch: any) => {
    try {
      const response = await axios(url);
      response.data = response.data.map((i:any)=>{
        return {...i,rid:`#${i.id}`,value:i.name,label:i.name}
      }) 
      dispatch({
        type : "STORE_ALL_ARTICLE_TYPES",
        payload : response.data
      })
      try{callback && callback("0",response.data)}catch(e){}
    } catch (error:any) {
      callback && callback("1",error.response)
//       return console.log(error.response);
    }
  };
};
export const ContactTypeAdd = async (data: any) => {
  try {
   let s =  await axios.post(`${url}`, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return s
  } catch (error:any) {
    if (error.data) {
      return {
        isError:true,
        message:error.data
      }
    }  
  }
};

export const updateContactType = async (data: any, id: any,) => {
  try {
    let s = await axios.put(`${url}/${id}`, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
//     console.log("updateContactType success bro", s)
    return s
  } catch (error:any) {
    if (error.data) {
//       console.log("this is error of update",error.data)
      return {
        isError:true,
        message:error.data
      }
    }  
  }
}

export const singleContactType = (id: any) => {
  return async (dispatch: any) => {
    try {
      const response = await axios.get(`${url}/${id}`);
      dispatch({
        type: "singleAssetStatus",
        payload: response,
      });
    } catch (error) {
//       return console.log(error);
    }
  };
};




export const multipalUpdateContactType = async (data: any, ids: any,status:any) => {
  
  
  try {
    let result = await axios.delete(`${bulkUpdate}${ids}&status=${status}`, data);
//     console.log("bulk delete",result)
    
   if (result.status==200){
    return true
    
   }
   else{
    return false
   }
  }  catch (error:any) {
    if (error.response) {
     
      return error.response.data
    }  
  }
};


export const softDeleteContactType = async (id: any) => {
  {
    try {
      let result = await axios.delete(`${bulkUpdate}${id}`);
      
     if (result.status==200){
      return true
      
     }
     else{
      return false
     }
    }  catch (error:any) {
      if (error.response) {
       
        return error.response.data
      }  
    }
  };
}
export const changeContactType = async (id: any, status:boolean) => {
  {
    try {
      let result = await axios.delete(`${configs.BASE_URL}/contacttypes/status/change?ids=${id}&status=${status}`);
     
      if (result.status==200){
      return true
      
     }
     else{
      return false
     }
    }  catch (error:any) {
      if (error.response) {
       
        return error.response.data
      }  
    }
  };
}

export const deleteContactType = async(id: any) => {
  {
    try {
      let s =  await axios.delete(`${deleteUrl}${id}`);
      
//       console.log("result after calling ContactStatusAdd", s)

      return s.data
    }  catch (error:any) {
      if (error.response) {
       
        return error.response.data
      }  
    }
  };
};
export const SnackBar =(msg: any,severity:string)=>{
  return async (dispatch: any) => {

  dispatch({
    type: ActionType.SNACKBAR,
    payload: {
      message: msg,
      severity: severity,
      open: true,
    },
  });
}
}

export const loading = (status: any) => {
  return {
    type: "loading",
    payload: status,
  };
};

export default ContactTypeAdd;